<template>
  <div>
    <container>
      <div class="info">
        <router-link to="/admin/past-run">&#x21A9; Back</router-link>
      </div>
      <div style="display:flex">
        <p style="font-size: large;padding: 14px 10px 0px 0px;">Recording:</p>
        <div style="min-width: 300px;">
          <audio id="my-audio" v-on:ended="playEnd" controls>
            <source
              :src="`https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`"
              type="audio/mp3"
            >
          </audio>
        </div>


      <div class="race_desc">
        <span>Description</span>
        <div id="wrapper_description">
          <div >{{race.description}}</div>
        </div>
      </div>


      <div>
        <button
          id="loaddatafb"
          class="btn btn--primary load_data"
          style="float: right;margin-left:10px"
          @click="fromFireBase()"
        >Load From Firebase
        </button>
      </div>


      </div>

      <br>
      <div v-if="currentChannel" class="channelInfo">
        <div>Channel : {{channel}}</div>
        <div>{{currentChannel.id}}</div>
        <div>{{currentChannel.pwd}}</div>
        <div>{{currentChannel.desc}}</div>
      </div>
      <br>

      <div style="display:flex">
        <span id="wrapper" class="question">
          <div id="leftcolumn">{{todayQuestion}}</div>
        </span>

        <span id="wrapper" class="question">
          <div id="leftcolumn">{{race.quoteOfDay}}</div>
        </span>
      </div>
      <div>
      <button
          id="downloadcsv"
          class="btn btn--primary load_data"
          style="float: right;margin-left:10px"
          @click="downloadCSV()"
        >Export as CSV
        </button>
        <toggle-button
          id="changed-font"
          @change="onToggle()"
          v-model="distanceInKm"
          :width="85"
          :height="30"
          :speed="480"
          :color="{unchecked: '#413b94', checked: '#ff5627'}"
          :labels="{checked: 'Km', unchecked: 'Miles'}"
          style="float:right;margin-bottom:10px"
        />
      </div>

      <v-table
        is-horizontal-resize
        :columns="columnsT"
        style="width:100%;font-size:10.5px"
        :column-cell-class-name="columnCellClass"
        :table-data="tableDataT"
        :show-vertical-border="true"
        :odd-bg-color="'#cfe2f3'"
        :title-row-height="60"
        :row-height="45"
        :border="1"
         @on-custom-comp="customCompFunc"
      ></v-table>
       <jw-pagination
        :items="runnerList"
        @changePage="onPageChange"
        :disableDefaultStyles="true">
       </jw-pagination>

       <lucky-live-runner :details = "detail" :show="showModal" @saved="onSaved"  @closed="onClosed"></lucky-live-runner>
    </container>
  </div>
</template>
<script>
  import 'vue-easytable/libs/themes-base/index.css'
  import Container from '@/components/Container'
  import LuckyLiveRunner from './LuckyLiveRunner'
  import {
    VTable,
    VPagination
  } from 'vue-easytable'
  import Vue from "vue"
  import moment from 'moment'
  Vue.component(VTable.name, VTable)
  Vue.component(VPagination.name, VPagination)
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    db
  } from '../../../firebase'
  import {
    sortBy,
    prop,
    groupBy,
    map,
    merge,
    find,
    propEq,
  } from 'ramda'
  import Races from '@/services/races'
  import RunnerInfo from '@/services/runnersByRace'
  import RaceQuestion from './Question'
  import LuckyLiveRunnerService from "@/services/luckyLiveRunner"
  import RunnersByRaceService from '@/services/runnersByRace'
  import JwPagination from '@/components/Forms/JwPagination'
  import axios from 'axios'
  import _ from 'lodash'
  export default {
    name: 'race-detail',
    computed: {
      ...mapGetters({
        race: 'Race/race',
        runners: 'Race/runners',
        question: 'RaceQuestion/question'
      }),

      startedDate() {
        return moment(this.race.startDate).format('YYYY/MM/DD')
      },
      trainerName() {
        if (this.race.trainer != undefined) {
          return this.race.trainer.firstName + this.race.trainer.lastName
        }
      }
    },
    data: () => ({
      audioFileNotFound:false,
      isPlay: false,
      distanceInKm:true,
      todayQuestion: '',
      quote: '',
      raceInfo: {},
      tableDataT: [],
      raceDate:'',
      showModal: false,
      channel:"",
      channelInfo:{
        "A":{
          'id':"takada@liverunapp.com",
          'pwd':"Tokyo2020",
          'desc':"LR Channel 1"
        },
        'B':{
          'id':"tomo.takada@gmail.com",
          'pwd':"Tokyo2020",
          'desc':"LRCh2"
        },
        'C':{
          'id':"tomo.takada@gmail.com",
          'pwd':"Tokyo2020"
        }
      },
      currentChannel:'',
      detail:{
        runner:{
            firstName:'',
            lastName:''
        }
      },
      runnerList :[],
      columnsT: [{
          field: "rank",
          title: 'Rank',
          width: 50,
          titleAlign: 'center',
          columnAlign: 'center',
          isFrozen: true,
          componentName:'lucky-runner-modal'
        },
        {
          field: "firstName",
          title: 'Runner Name',
          width: 95,
          titleAlign: 'center',
          columnAlign: 'center',
          formatter: function (rowData, rowIndex, pagingIndex, field) {
            return rowData.isNew ? '<span style="color:red;font-weight: bold;">' + rowData.firstName +
              '</span>' : rowData.firstName
          },
          isFrozen: true
        },
        {
          field: "id",
          title: 'ID',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center',
          componentName: 'runner-id',
          isFrozen: true
        },
        {
          field: "medal",
          title: 'Mdl',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center',
          isFrozen: true
        },
        {
          field: "memo",
          title: 'Memo',
          width: 200,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "lastName",
          title: 'Location',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center',
        },
        {
          field: "catchPhrase",
          title: 'CatchPhrase',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "gender",
          title: 'Sex',
          width: 30,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "distance",
          title: 'distance/KM',
          width: 90,
          titleAlign: 'center',
          columnAlign: 'center',
        },
        {
          field: "gap",
          title: 'Gap (M)',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "pace",
          title: 'Current Pace(min/km)',
          width: 80,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalPace",
          title: 'Total Pace (min/km)',
          width: 70,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalRuns",
          title: '#of Run',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalDistance",
          title: 'Total KM',
          width: 65,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "daysSinceLastRun",
          title: 'Days since last LiveRuns',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "questionAnswer",
          title: 'Questionaire',
          width: 900,
          titleAlign: 'center',
          columnAlign: 'left',
          componentName: 'answers',
          isResize:true
        }
      ],
    }),
    methods: {
      ...mapActions({
        getRaceQuote: 'RaceQuote/getOne',
        getRace: 'Race/get',
      }),
      async initialize() {
        //get all data from API'S
        this.$store.dispatch('RaceQuestion/getOne', this.$route.params.raceId).then(() => {
          this.todayQuestion = this.question.question
        })
        this.$store.dispatch('Race/get', this.$route.params.raceId).then(() => {
          this.raceDate = this.race.startDate
          this.getRaceQuote(moment(this.race.startDate).format('YYYY-MM-DD')).then((e) => {
          this.quote = e.data.quote
          })
        })

        if(this.race.mobileChannelToPlay){
          this.getChannel(this.race.mobileChannelToPlay.trim())
        }

        var LuckyLiveRunnerInfo=[]
        await LuckyLiveRunnerService.getLuckyLiveRunnersByRaceId(this.$route.params.raceId).then(response => {
          LuckyLiveRunnerInfo=response.data
        }).catch(error => console.log("err--->>",error))

        var LuckyLiveRunners = LuckyLiveRunnerInfo && LuckyLiveRunnerInfo.content ?LuckyLiveRunnerInfo.content:[]


        var allrunner =[]
        await RunnerInfo.getAll(this.$route.params.raceId).then((data) => {
          //console.log("data---",data.data)
          allrunner = data.data
        })

        // FIXED: Get ALL runner profile data once (like live run page does) instead of one-by-one
        var allRunnerProfiles = []
        await RunnerInfo.getByIds(this.$route.params.raceId, []).then((data) => {
          allRunnerProfiles = data.data
        })

        var finalData = []
        var lastRunnerDistance = 0
        var count = 0
        const sortByPositions = sortBy(prop('rank'))
        Races.getFinalresults(this.$route.params.raceId).then((data) => {
          var runnerData = data.data
          //console.log("data2---",runnerData)
          var unsubscribedrunners = this.includeAllrunners(runnerData, allrunner)
          if (unsubscribedrunners.length != 0) {
            unsubscribedrunners.forEach(runnerdata => {
              var runner = {
                  'unsubscribed' : true,
                  'runner':runnerdata,
                  'runnerPlace':null
                }
              runner['unsubscribed'] = true
              runnerData.push( runner)
            })
          }
          let requests = runnerData.map(async(runner) => {
                return new Promise(async(resolve) => {
                count++
                var raceInfo = {}

                raceInfo['isLuckyLiveRunner']=false
                var LuckyLiveRunnerInfo = LuckyLiveRunners.find(propEq('runnerId', runner.runner.id))
                if(LuckyLiveRunnerInfo!=undefined){
                    raceInfo['isLuckyLiveRunner']=true
                    raceInfo['LuckyLiveRunnerInfo']=LuckyLiveRunnerInfo
                }else{
                    raceInfo['LuckyLiveRunnerInfo']={}
                }

                if(runner.unsubscribed!=undefined){
                  raceInfo['unsubscribed']=runner.unsubscribed
                }else{
                  raceInfo['unsubscribed']=false
                }
                raceInfo['rank'] = runner.runnerPlace
                raceInfo['firstName'] = runner.runner.firstName
                raceInfo['id'] = runner.runner.id
                raceInfo['lastName'] = runner.runner.lastName
                raceInfo['gender'] = runner.runner.gender
                //raceInfo['distance'] = (runner.distance / 1000).toFixed(2)

                raceInfo['pace'] = 0
                raceInfo['totalPace'] = 0
                //Calculate Gap
                var gap
                if (count == 1) {
                  gap = 0
                } else {
                  gap = lastRunnerDistance - (runner.distance / 1000).toFixed(2)
                }
                lastRunnerDistance = (runner.distance / 1000).toFixed(2)
                gap = gap.toFixed(2) / 0.0010000
                raceInfo['gap'] = gap ? parseInt(gap.toFixed(2)):'0'

                //covert km to mile
                if(this.distanceInKm) {
                  raceInfo['distance'] = runner.distance ? (runner.distance / 1000).toFixed(2):'0.00'
                  //raceInfo['gap'] = parseInt(gap.toFixed(2))
                  this.columnsT[8].title='distance/KM'
                  this.columnsT[10].title='Current Pace(min/km)'
                  this.columnsT[11].title='Total Pace (min/km)'
                } else {
                  raceInfo['distance'] = runner.distance ? ((runner.distance / 1000) * 0.62137).toFixed(2):'0.00'
                  //raceInfo['gap'] = parseInt(gap * 0.62137)
                  this.columnsT[8].title='distance/Miles'
                  this.columnsT[10].title='Current Pace(min/mi)'
                  this.columnsT[11].title='Total Pace (min/mi)'
                }

                // await RunnersByRaceService.getRunnerMedals(runner.runner.id).then((response) => {
                //   //show count for medal 60
                //   const medal60 = response.data.find((medal=>medal.medal.id === 60))
                //   if(medal60){
                //     raceInfo['medal'] = medal60.count
                //   }else{
                //     raceInfo['medal'] = '-'
                //   }
                // })

                // FIXED: Look up runner profile from pre-fetched data instead of making individual API calls
                const runnerProfile = allRunnerProfiles.find(p => 
                  (p.runner && p.runner.id === runner.runner.id) || p.id === runner.runner.id
                )
                
                if (runnerProfile) {
                  raceInfo['memo'] = runnerProfile.runnerMemo ? runnerProfile.runnerMemo.memo : '-'
                  raceInfo['totalRuns'] = runnerProfile.totalRuns ? runnerProfile.totalRuns : '-'
                  raceInfo['catchPhrase'] = runner.runner.catchPhrase || '-'
                  //['totalDistance'] = runnerProfile.totalDistance ? runnerProfile.totalDistance : '-'

                  // convert km to mile
                  if(this.distanceInKm) {
                    // raceInfo['totalDistance'] = runnerProfile.totalDistance ? runnerProfile.totalDistance : '-'
                    raceInfo['totalDistance'] = runnerProfile.totalDistance ? runnerProfile.totalDistance.split(" ")[0] : '-'
                    this.columnsT[13].title='Total KM'
                  } else {
                    // raceInfo['totalDistance'] = runnerProfile.totalDistance ? (runnerProfile.totalDistance.split(" ")[0] * 0.62137).toFixed(2) +" mi" : '-'
                    raceInfo['totalDistance'] = runnerProfile.totalDistance ? (runnerProfile.totalDistance.split(" ")[0] * 0.62137).toFixed(2): '-'
                    this.columnsT[13].title='Total Miles'
                  }

                  raceInfo['daysSinceLastRun'] = runnerProfile.daysSinceLastRun ? runnerProfile.daysSinceLastRun : '0'

                  raceInfo['questionAnswer'] = runnerProfile.questionAnswer ? runnerProfile.questionAnswer
                    .answer : '-'
                  // FIXED: postRunAnswer is a string, not an object with .answer property  
                  // Also, when fetching all runners at once (empty array), backend returns proper postRunAnswer
                  raceInfo['postQuestionAnswer'] = runnerProfile.postRunAnswer ? runnerProfile.postRunAnswer : '-'
                } else {
                  // Fallback if runner profile not found
                  raceInfo['memo'] = '-'
                  raceInfo['totalRuns'] = '-'
                  raceInfo['catchPhrase'] = runner.runner.catchPhrase || '-'
                  raceInfo['totalDistance'] = '-'
                  raceInfo['daysSinceLastRun'] = '0'
                  raceInfo['questionAnswer'] = '-'
                  raceInfo['postQuestionAnswer'] = '-'
                }
                
                finalData.push(raceInfo)
                resolve()
              })
            })


          Promise.all(requests).then(() => {
            // this.tableDataT = sortByPositions(finalData)
            // //put null rank runner at bottom
            // this.tableDataT = _.sortBy(this.tableDataT , function (data) {
            //   return data.rank ? 0 : 1
            // })
            var runnerData = sortByPositions(finalData)
            var sortRunnerData = _.sortBy(runnerData , function (data) {
               return data.rank ? 0 : 1
             })
            this.runnerList= sortRunnerData

          })

          // runnerData.forEach(async runner => {
          //   count++
          //   var raceInfo = {}

          //   raceInfo['isLuckyLiveRunner']=false
          //   var LuckyLiveRunnerInfo = LuckyLiveRunners.find(propEq('runnerId', runner.runner.id))
          //   if(LuckyLiveRunnerInfo!=undefined){
          //       raceInfo['isLuckyLiveRunner']=true
          //       raceInfo['LuckyLiveRunnerInfo']=LuckyLiveRunnerInfo
          //   }else{
          //       raceInfo['LuckyLiveRunnerInfo']={}
          //   }

          //   if(runner.unsubscribed!=undefined){
          //     raceInfo['unsubscribed']=runner.unsubscribed
          //   }else{
          //     raceInfo['unsubscribed']=false
          //   }
          //   raceInfo['rank'] = runner.runnerPlace
          //   raceInfo['firstName'] = runner.runner.firstName
          //   raceInfo['id'] = runner.runner.id
          //   raceInfo['lastName'] = runner.runner.lastName
          //   raceInfo['gender'] = runner.runner.gender
          //   //raceInfo['distance'] = (runner.distance / 1000).toFixed(2)

          //   raceInfo['pace'] = 0
          //   raceInfo['totalPace'] = 0
          //   //Calculate Gap
          //   var gap
          //   if (count == 1) {
          //     gap = 0
          //   } else {
          //     gap = lastRunnerDistance - (runner.distance / 1000).toFixed(2)
          //   }
          //   lastRunnerDistance = (runner.distance / 1000).toFixed(2)
          //   gap = gap.toFixed(2) / 0.0010000
          //   raceInfo['gap'] = gap ? parseInt(gap.toFixed(2)):'0'

          //   //covert km to mile
          //   if(this.distanceInKm ){
          //     raceInfo['distance'] = runner.distance ? (runner.distance / 1000).toFixed(2):'0.00'
          //     //raceInfo['gap'] = parseInt(gap.toFixed(2))
          //     this.columnsT[6].title='distance/KM'
          //     this.columnsT[8].title='Total Pace (min/km)'
          //     this.columnsT[9].title='Current Pace (min/km)'
          //   }else{
          //     raceInfo['distance'] = runner.distance ? ((runner.distance / 1000) * 0.62137).toFixed(2):'0.00'
          //     //raceInfo['gap'] = parseInt(gap * 0.62137)
          //     this.columnsT[6].title='distance/Miles'
          //     this.columnsT[8].title='Total Pace (min/mi)'
          //     this.columnsT[9].title='Current Pace (min/mi)'
          //   }

          //   // await RunnersByRaceService.getRunnerMedals(runner.runner.id).then((response) => {
          //   //   //show count for medal 60
          //   //   const medal60 = response.data.find((medal=>medal.medal.id === 60))
          //   //   if(medal60){
          //   //     raceInfo['medal'] = medal60.count
          //   //   }else{
          //   //     raceInfo['medal'] = '-'
          //   //   }
          //   // })

          //   await RunnerInfo.getByIds(this.$route.params.raceId, runner.runner.id).then((res) => {
          //     raceInfo['memo'] = res.data[0].runnerMemo ? res.data[0].runnerMemo.memo : '-'
          //     raceInfo['totalRuns'] = res.data[0].totalRuns ? res.data[0].totalRuns : '-'
          //     //['totalDistance'] = res.data[0].totalDistance ? res.data[0].totalDistance : '-'

          //     // convert km to mile
          //     if(this.distanceInKm ){
          //       // raceInfo['totalDistance'] = res.data[0].totalDistance ? res.data[0].totalDistance : '-'
          //       raceInfo['totalDistance'] = res.data[0].totalDistance ? res.data[0].totalDistance.split(" ")[0] : '-'
          //       this.columnsT[11].title='Total KM'
          //     }
          //     else{
          //       // raceInfo['totalDistance'] = res.data[0].totalDistance ? (res.data[0].totalDistance.split(" ")[0] * 0.62137).toFixed(2) +" mi" : '-'
          //       raceInfo['totalDistance'] = res.data[0].totalDistance ? (res.data[0].totalDistance.split(" ")[0] * 0.62137).toFixed(2): '-'
          //       this.columnsT[11].title='Total Miles'
          //     }

          //     raceInfo['daysSinceLastRun'] = res.data[0].daysSinceLastRun ? res.data[0].daysSinceLastRun : '0'

          //     raceInfo['questionAnswer'] = res.data[0].questionAnswer ? res.data[0].questionAnswer
          //       .answer : '-'
          //     raceInfo['postQuestionAnswer'] = res.data[0].postRunAnswer ? res.data[0].postRunAnswer
          //       .answer : '-'
          //     finalData.push(raceInfo)
          //   })
          //   // this.tableDataT = sortByPositions(finalData)

          //   // //put null rank runner at bottom
          //   // this.tableDataT = _.sortBy(this.tableDataT , function (data) {
          //   //   return data.rank ? 0 : 1
          //   // })
          // })




        })


      },

      includeAllrunners(finalRunners, allRunners) {
        var result = allRunners.filter(function (o1) {
            return !finalRunners.some(function (o2) {
                return o1.id === o2.runner.id
            })
        })
        return result
    },
     onPageChange(pageOfItems) {
        this.tableDataT  = pageOfItems
        if(this.tableDataT.length>0){
          $('.v-table-views ').css('max-height','612px')
          $($(".v-table-body")[0]).css('max-height','550px')
          $($(".v-table-body")[1]).css('max-height','550px')
        }
      },

      async onToggle(){
          if(this.$envdistanceIn === 'Km'){
            this.distanceInKm = false
            Vue.prototype.$envdistanceIn = 'Miles'
            window.localStorage.setItem('distanceIn','Miles')
            this.initialize()
          }else if(this.$envdistanceIn ==='Miles'){
            this.distanceInKm = true
            Vue.prototype.$envdistanceIn = 'Km'
            window.localStorage.setItem('distanceIn','Km')
            this.initialize()
          }
       },

      fromFireBase() {
        this.$router.push({
          name: 'past-run-firebase',
          params: {
            pastRun: true,
            raceId: this.$route.params.raceId
          }
        })
      },
      downloadCSV() {
        let csvData = []
        let tempRow = []
        this.columnsT.map((col) => {
            let val = col.title || ''
            val = val.replace('#', '')
            tempRow.push(val)
        })
        csvData.push(tempRow)
        const getValue = (value2) => {
            return value2.replace('#', '').replace(',', '').replace(/(\r\n|\n|\r)/gm, "").trim()
        }
        if(this.runnerList.length) {
            this.runnerList.map((runner, index) => {
               tempRow = []
               this.columnsT.map((col) => {
                let val2 = runner[col.field] || ''
                if(typeof val2 === 'string') {
                    val2 = getValue(val2)
                }
                let val3 = ''
                if(col.title === 'Questionaire') {
                    val3 = getValue(runner['postQuestionAnswer'] || '')
                    tempRow.push(`"${val2}\n${val3}"`)
                } else {
                    tempRow.push(val2)
                }
               })
               csvData.push(tempRow)
               tempRow = []
            })
        	let csvContent = "data:text/csv;charset=utf-8,"
        	csvData.map((infoArray, index) => {
			let dataString = infoArray.join(",")
			csvContent +=  dataString+ "\n"
		})

        var downloadLink = document.createElement("a")
            downloadLink.href = csvContent
            const fId = this.race.id
            const fDate = new Date().toISOString().split('T')[0]
            downloadLink.download = `${fId ? fId + '-' : 'race-'}${fDate ? fDate : 'new'}.csv`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        }
      },
      columnCellClass(rowIndex, columnName, rowData) {

        if(rowData.unsubscribed){
                return 'gray'
        }
        if (rowData.isTotalPaceGreater && columnName === 'totalPace') {
          return 'column-cell-class-name-test'
        }

        if (columnName === 'questionAnswer') {
          return 'column-cell-class-name-test1'
        }
        if(columnName == 'firstName' && rowData.firstName !=undefined && rowData.firstName.length > 8){
          return 'column-cell-class-name-test-memo'
        }

        if (columnName == 'lastName' && rowData.lastName != null && rowData.lastName.length > 7) {
          return 'column-cell-class-name-test-memo'
        }

        if (rowData.memo != null && rowData.memo.length > 17) {
          return 'column-cell-class-name-test-memo'
        } else {
          return ""
        }


      },
      customCompFunc(params){
        params.race=this.race
        console.log("parm--",params)
        //console.log("params---",params)
        this.detail = params
        this.showModal = true
      },
       onClosed(){
        this.showModal = false
      },
      onSaved(data,index){
          this.tableDataT[index].isLuckyLiveRunner = true
          this.tableDataT[index].LuckyLiveRunnerInfo = data
          this.showModal = false
      },
    //   play() {
    //     console.log("0000000")
    //     var myAudio = document.getElementById('my-audio')
    //     myAudio.load()
    //     myAudio.play()
    //     this.isPlay = true
    //   },
    //   pause() {
    //     var myAudio = document.getElementById('my-audio')
    //     myAudio.load()
    //     myAudio.pause()
    //     this.isPlay = false
    //   },
    //   playEnd(){
    //      this.isPlay = false
    //   },
    //   downloadItem(url) {
    //     axios.get(url, {
    //         responseType: 'blob'
    //       })
    //       .then(({
    //         data
    //       }) => {
    //         const blob = new Blob([data], {
    //           type: 'audio/mp3'
    //         })
    //         let link = document.createElement('a')
    //         link.href = window.URL.createObjectURL(blob)
    //         link.download = `${this.race.id}.mp3`
    //         link.click()
    //       })
    //   }

    // },

    play() {
        var myAudio = document.getElementById('my-audio')
        //myAudio.load()
        myAudio.play()
        this.isPlay = true
      },
      pause() {
        var myAudio = document.getElementById('my-audio')
        //myAudio.load()
        myAudio.pause()
        this.isPlay = false
      },
      playEnd(){
         this.isPlay = false
      },
      downloadItem() {
        var url = `https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`
        axios.get(url, {
            responseType: 'blob'
          })
          .then(({
            data
          }) => {
            const blob = new Blob([data], {
              type: 'audio/mp3'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${this.race.id}.mp3`
            link.click()
          })
      },
      checkAudioUrl(){
        var that = this
        $.ajax({
                url:`https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`,
                error: function()
                {
                  that.audioFileNotFound = true
                },
                success: function()
                {
                  that.audioFileNotFound = false
                }
            })
      },
      async getChannel(mobileChannelToPlay){
        switch (mobileChannelToPlay) {
            case 'https://api.spreaker.com/v2/episodes/18340960/play':
              this.channel = 'A'
              this.currentChannel = this.channelInfo.A
              break
            case 'https://api.spreaker.com/v2/episodes/20496650/play':
              this.channel = 'B'
              this.currentChannel = this.channelInfo.B
              break
            case 'https://edge.mixlr.com/channel/ygdpy':
              this.channel = 'C'
              this.currentChannel = this.channelInfo.C
              break
        }
        console.log("current>>>>",this.currentChannel)


      },
    },
    created() {
      this.$store.dispatch('Race/getRunners', this.$route.params.raceId)
      this.checkAudioUrl()
      this.initialize()
      if(this.$envdistanceIn == 'Km'){
        this.distanceInKm = true
      }else{
        this.distanceInKm = false
      }
    },
    components: {
      Container,
      LuckyLiveRunner,
      JwPagination
    }
  }


  Vue.component('runner-id', {
    template: `<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.id}}</a>&nbsp
        </span>`,
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      runnerData() {

        let route = this.$router.resolve({
          name: 'runner-data',
          params: {
            runnerId: this.rowData.id,
            raceId: this.$route.params.raceId
          }
        })
        window.open(route.href, '_blank')
      }
    },
    created() {
      //   this.id =   this.rowData.id
    }
  })
  Vue.component('answers', {
    template: `<div style = "width:890px">
                    <a href= "javascript:void(0)" @click  = isPreRead() v-bind:style="{ color: preactiveColor }">{{rowData.questionAnswer}}</a>
                    <br/>
                    <hr style ="margin-bottom: 4px;margin-top: 4px;">
                    <span >
                    <a href= "javascript:void(0)" @click  = isPostRead() v-bind:style="{ color: postactiveColor }"> {{rowData.postQuestionAnswer}}</a>
                    </span>
                  </div>`,
    data: () => ({
      //   id:null
      preactiveColor: 'black',
      postactiveColor: 'red'
    }),
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      isPreRead() {
        this.preactiveColor = '#a33ef1'
        db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
          'preAnswerRead': true,
          'isRunnerCalled': true,
        })
      },
      isPostRead() {
        this.postactiveColor = '#a33ef1'
        db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
          'postAnswerRead': true,
          'isRunnerCalled': true,
        })
      }
    },

    created() {
      let that = this
      let AnswersInterval = setInterval(async function () {
        let liveStatus = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/statusLive`).once(
          'value')
        if (liveStatus.val() === 'finished') {
          clearInterval(AnswersInterval)
        }
        let preAnswerRead = await db.ref(
          `/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/preAnswerRead`).once(
          'value')
        let postAnswerRead = await db.ref(
            `/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/postAnswerRead`)
          .once('value')
        if (preAnswerRead.val()) {
          that.preactiveColor = '#a33ef1'
        } else {
          that.preactiveColor = 'black'
        }
        if (postAnswerRead.val()) {
          that.postactiveColor = '#a33ef1'
        } else {
          that.postactiveColor = 'red'
        }
      }, 1000)
    }
  })

  Vue.component('lucky-runner-modal',{
        template:`
        <div>
            <button id="tickBtn" v-if="rowData.isLuckyLiveRunner"></button>
            <span @click.stop.prevent="openEditModal()" style="cursor:pointer">{{rowData.rank}}</span>
        </div>
           `,
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            },
        },
        methods:{
          openEditModal(){
                let params = {columeName:"luckyLiveRunner",runner:this.rowData,index:this.index}
                this.$emit('on-custom-comp',params)
            }
        },
        created() {
        }
  })

</script>

<style>
 #tickBtn {
        width: 20px;
        height: 13px;
        /* margin-top: 10px; */
        /* float: left; */
        margin-right: 2px;
        background-image: url(../../../assets/tick.png);
        background-repeat: no-repeat;
        background-color: transparent;
        border: none;
    }
</style>
<style lang="stylus" scoped>

  .info
    display flex
    flex-flow row wrap
    font-size 16px
    margin 0 0 15px

    a, div
      margin 0 15px 0 0

</style>
<style>
  .question {
    border: 1px solid #66666673;
    border-radius: 20px;
    padding: 10px 15px 25px 15px;
    width: 100%;
  }

  #wrapper {
    width: 50% !important;
    padding-left: 0px !important;
    padding-bottom: 1rem !important;
    padding-right: 0 !important;
    margin-bottom: 1rem;
  }

  #wrapper_description {
    /* width: 50% !important;
    padding-left: 5px !important;
    padding-bottom: 1rem !important;
    padding-right: 5px !important;
    margin-left: 10px; */
    border: 1px solid #66666673;
    padding: 5px 10px;
    border-radius: 20px;
  }
  .race_desc{
    width:50%;
    margin-left:10px
  }
  .race_desc span {
    font-weight: 900;
    font-size: 16px;
    margin-left: 20px;
  }


  .loadData {
    font-weight: 700;
    color: #fff;
    background-color: #423799;
    padding: 0px 10px;
    /* text-transform: uppercase; */
    position: sticky;
    left: 90%;
    transform: translateX(-50%);
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .load_data{
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

</style>



// WEBPACK FOOTER //
// RaceDetail.vue?567af3f4